module.exports = require("colors/safe");


//////////////////
// WEBPACK FOOTER
// external "colors/safe"
// module id = 58
// module chunks = 0